import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '../codex/design-system/App'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('design-system')
  if (container) {
    const root = ReactDOM.createRoot(container)
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  }
})
